import React from 'react';
import { Box } from '@chakra-ui/react';
import Header from 'components/layout/Header';
import type { BoxProps } from '@chakra-ui/react';

const containerStyle = {
  height: '100%',
  width: '100%',
  overflowX: 'hidden',
};

const bodyStyle = {
  height: `calc(100vh - ${Header.Height})`,
  width: '100%',
  maxWidth: '100vw',
  overflowY: 'auto',
  // Keep every page within the viewport width; wide content (tables, etc.)
  // must scroll inside its own container rather than push the page sideways.
  overflowX: 'hidden',
};

type TBasePageWithTopNavProps = {
  children: React.ReactNode;
  sx?: BoxProps['sx'];
};

const BasePageWithTopNav = ({ sx, children }: TBasePageWithTopNavProps) => {
  return (
    <Box sx={containerStyle}>
      <Header />
      <Box id="mercator-body" sx={{ ...bodyStyle, ...sx }}>
        {children}
      </Box>
    </Box>
  );
};

export default BasePageWithTopNav;
